import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  SetTheResignActions,
  SetTheResignDelete,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  setDropDownRenders,
  setTheNew_exit_flowZone,
  setTheNew_exitflowState,
  setThenew_exit_flowRegion,
  setheNew_exit_flwdesignationStatus,
  setTheNew_exit_flowStateStatus,
  resetExitFlowList,
  setthe_exitflow_managements,
  setTablePositionPersist,
  setTheExitNewFlowDetailsExportActions,
  setthe_eployee_exit_flow_employee_filters,
  setThenew_exit_flowToDate,
  setThenew_exit_flowFromDate,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import Delete from "../../AppComponent/Popup/Delete";
import Select from "react-select";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ThumbsImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-13.svg";
import BanImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-26.svg";
import useDebouncedEffect from "use-debounced-effect";
import ExitApproval from "../ExitFlow/ExitApproval";
import Exitflowaaprove from "./Exitflowaaprove";
import { DateRangePicker } from "rsuite";
import dayjs from "dayjs";
import { addDays, endOfWeek, isAfter, startOfWeek, subDays } from "date-fns";

const Exitnewlist = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );

  const state = useSelector((state) => state);
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );
  const dateRangeRef = useRef(null);

  const UserObjectData = useSelector((state) => state.users.UserData);
  const [sno, setsno] = useState(0);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setData] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.ExitnewflowlistRequestedPagelist?.page == undefined
      ? 1
      : TablePositionPersist.ExitnewflowlistRequestedPagelist.page,
  );

  const [search, setsearch] = useState(
    TablePositionPersist?.ExitnewflowlistRequestedPagelist?.search ==
      undefined ||
      TablePositionPersist?.ExitnewflowlistRequestedPagelist?.search == ""
      ? ""
      : TablePositionPersist.ExitnewflowlistRequestedPagelist.search,
  );
  const today_day = dayjs().format("YYYY-MM-DD");

  var it = convert(state.exit_flow_managemanets.Exit_flowFromDate);
  var gt = convert(state.exit_flow_managemanets.Exit_flowToDate);

  const [range, setrange] = useState(
    state.exit_flow_managemanets.Exit_flowToDate == ""
      ? [today_day, today_day]
      : [it, gt],
  );
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const oldemloyeeOptions = [
    {
      value: true,
      label: "EXISTING EMPLOYEE",
    },
    {
      value: false,
      label: "NEW EMPLOYEE",
    },
  ];

  const [oldemplo, setoldemp] = useState({
    old_employee: state?.EmployeeVerificationsNeed
      ?.Employee_Exit_flows_Employee_filter_old_new
      ? state?.EmployeeVerificationsNeed
          ?.Employee_Exit_flows_Employee_filter_old_new?.value
      : false,
  });
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const handlechangedate = (value) => {
    // console.log(value, "vlues");
    setdtPageindex(1);

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  const getZoomFactor = () => {
    const zoom = document.body.style.zoom;
    return zoom ? parseFloat(zoom) / 100 : 1;
  };
  const alignDateRangePicker = (pickerNode) => {
    const picker = pickerNode?.root || pickerNode?.container || pickerNode;

    const popup = document.querySelector(
      ".rs-picker-popup.rs-picker-popup-daterange",
    );

    if (!picker || !popup) return;

    const zoom = getZoomFactor();
    const rect = picker.getBoundingClientRect();

    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    const viewportWidth = window.innerWidth / zoom;
    const viewportHeight = window.innerHeight / zoom;

    const scrollX = window.scrollX / zoom;
    const scrollY = window.scrollY / zoom;

    let left = rect.right / zoom - popupWidth + scrollX;
    let top = rect.bottom / zoom + 8 + scrollY;

    if (left < 8) left = 8;
    if (left + popupWidth > viewportWidth - 8) {
      left = viewportWidth - popupWidth - 8;
    }

    if (top + popupHeight > viewportHeight + scrollY - 8) {
      top = rect.top / zoom - popupHeight - 8 + scrollY;
    }

    popup.style.position = "absolute";
    popup.style.left = `${left}px`;
    popup.style.top = `${top}px`;
  };

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "0",
      label: "ALL",
    },
    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [filterForWhite, setFilters] = useState({
    white_collar:
      state.exit_flow_managemanets?.Exit_flowdesignation?.value == ""
        ? ""
        : state.exit_flow_managemanets?.Exit_flowdesignation?.value == 1
          ? false
          : state.exit_flow_managemanets?.Exit_flowdesignation?.value == 0 &&
            true,
  });
  const HandleEMprole = (e) => {
    if (e != null) {
      dispatch(setheNew_exit_flwdesignationStatus(e));

      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(
          setheNew_exit_flwdesignationStatus({ value: "0", label: "ALL" }),
        );
      }
    }
  };

  const FileterState = {
    status: state.exit_flow_managemanets.Exit_flowStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  const [OldEmp, setOldEMp] = useState(
    state?.EmployeeVerificationsNeed
      ?.Employee_Exit_flows_Employee_filter_old_new
      ? state?.EmployeeVerificationsNeed
          ?.Employee_Exit_flows_Employee_filter_old_new
      : {
          label: "NEW EMPLOYEE",
          value: false,
        },
  );
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.exit_flow_managemanets.Exit_flowRegion,
  );
  const [multiselect3, setMuliselect3] = useState(
    state.exit_flow_managemanets.Exit_flowZone,
  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setDatas] = useState({
    zone: state.exit_flow_managemanets.Exit_flowZone?.value,
    state: state.exit_flow_managemanets?.Exit_flowtate?.value,
    region: state.exit_flow_managemanets.Exit_flowRegion?.value,
  });
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "ALL" }
    state.exit_flow_managemanets?.Exit_flowtate,
    // state.ClientBranchIDs.StateName,
  ]);

  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];
  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      status: selectVal?.status,
      state: data?.state,
      region: data?.region,
      zone: data?.zone,
      from_date: range[0],
      to_date: range[1],
      range: true,
      old_employee: oldemplo.old_employee,
    };
    // if (
    //   state.ExitFlow_List.exitFlowList.length == 0 ||
    //   TablePositionPersist?.ExitnewflowlistRequestedPagelist?.page !=
    //     dtpageindex ||
    //   TablePositionPersist?.ExitnewflowlistRequestedPagelist?.search !=
    //     search ||
    //   TablePositionPersist?.ExitnewflowlistRequestedPagelist?.status !=
    //     selectVal.status ||
    //   TablePositionPersist?.ExitnewflowlistRequestedPagelist?.state !=
    //     data.state ||
    //   TablePositionPersist?.ExitnewflowlistRequestedPagelist?.region !=
    //     data.region ||
    //   TablePositionPersist?.ExitnewflowlistRequestedPagelist?.zone !=
    //     data.zone ||
    //   TablePositionPersist?.ExitnewflowlistRequestedPagelist?.isApproved
    // ) {
    dispatch(resetExitFlowList(payload));
    dispatch(
      setTablePositionPersist({
        data: payload,
        pageName: "ExitnewflowlistRequestedPagelist",
      }),
    );
    // }

    currentRef.current.scrollTop = sessionStorage.getItem(
      "NewExitflowlistrequestScrollpages",
    );
  }, [selectVal, data, dtpageindex, search, oldemplo, range]);

  useEffect(() => {
    setData(state.resignCall.ResginDatas);
  }, [state.resignCall.ResginDatas]);

  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the-
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setDatas({
        ...data,
        region: selectedVal.value,
      });
      dispatch(setThenew_exit_flowRegion(selectedVal));
      dispatch(setTheNew_exit_flowZone({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setDatas({
        ...data,
        region: "",
        zone: "",
      });
      dispatch(setThenew_exit_flowRegion({ value: "", label: "ALL" }));
      dispatch(setTheNew_exit_flowZone({ value: "", label: "ALL" }));
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setDatas({
        ...data,
        zone: selectedVal.value,
      });
      dispatch(setTheNew_exit_flowZone(selectedVal));
    }
    if (selectedVal == null) {
      setDatas({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheNew_exit_flowZone({ value: "", label: "ALL" }));
    }
  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheNew_exitflowState(selectedVal));
      dispatch(setThenew_exit_flowRegion({ value: "", label: "ALL" }));
      dispatch(setTheNew_exit_flowZone({ value: "", label: "ALL" }));

      // console.log(selectedVal, "asfad");
      setDatas({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheNew_exitflowState({ value: "", label: "ALL" }));
      dispatch(setThenew_exit_flowRegion({ value: "", label: "ALL" }));
      dispatch(setTheNew_exit_flowZone({ value: "", label: "ALL" }));

      setDatas({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
      }
    },
    500,
    [SearchDebounance],
  );

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    [],
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (row.row.original.id != undefined && row.row.original.id != null) {
            const userId = row.row.original.id;
            const lastFourDigits = userId.slice(-6);
            return <p className="m-0">{lastFourDigits}</p>;
          }
        },
      },
      //             {
      //   Header: "U-ID",
      //   accessor: "user_id.local_uid",
      //   Cell: ({ row }) => {
      //     const userId = row.original?.user_id?.local_uid;

      //     // Handle null, undefined, empty string, or whitespace
      //     const displayValue =
      //       userId == null || String(userId).trim() == "" ? "--" : userId;

      //     return <p className="PTAGs">{displayValue}</p>;
      //   },
      // },

      {
        Header: "Employee Code",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div className="UserName" style={{ cursor: "pointer" }}>
                <div className="">
                  <span>
                    {row.row.original.user_id?.user_uid != null &&
                    row.row.original.user_id?.user_uid != undefined &&
                    row.row.original.user_id?.user_uid != ""
                      ? row.row.original.user_id?.user_uid
                      : "--"}
                  </span>
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: "Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original.user_id.first_name}</span>
            </>
          );
        },
      },

      {
        Header: "Created date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;

          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

          return (
            <>
              <span>
                {`${
                  row.row.original.created_at.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </span>
            </>
          );
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: (row) => {
          const originalString = row.row.original.status;
          const capitalizedString = capitalizeFirstLetter(originalString);
          return (
            <>
              {row.row.original.status != undefined ? (
                <>
                  {row.row.original.status.toLowerCase() == "pending" ? (
                    <div className="StatusList">
                      <img src={Pendingimg} />
                      <span>{capitalizedString}</span>
                    </div>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() == "decline" ? (
                        <div className="StatusList">
                          <div className="DeclineStatus">
                            <span style={{ fontSize: "14px" }}>x</span>
                          </div>
                          <span>{capitalizedString}</span>
                        </div>
                      ) : (
                        <>
                          {row.row.original.status.toLowerCase() ==
                          "approved" ? (
                            <div className="StatusList">
                              <img src={correctIcons} />
                              <span>{capitalizedString}</span>
                            </div>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
              >
                {row.row.original.status.toLowerCase() === "approved" ? (
                  <button className=" btn Status" component="span" disabled>
                    <span className="OuterActionSpan">
                      <span className="EditImages">
                        <img src={ThumbsImage} />
                      </span>

                      <span className="ActionsList"> Approved</span>
                    </span>
                  </button>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() === "decline" ? (
                      <button className=" btn Status" component="span" disabled>
                        <span className="OuterActionSpan">
                          <span className="EditImages">
                            <img src={ThumbsImage} />
                          </span>

                          <span
                            className="ActionsList"
                            style={{ paddingLeft: "4px", paddingTop: "2px" }}
                          >
                            {"Decline"}
                          </span>
                        </span>
                      </button>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() === "pending" ? (
                          <button
                            className=" btn Status"
                            component="span"
                            onClick={(e) => {
                              dispatch(
                                setthe_exitflow_managements(row.row.original),
                              );
                              setEmployeePop(true);
                              setEmployeeIDs(row.row.original.id);
                            }}
                          >
                            {" "}
                            <span className="OuterActionSpan">
                              <span className="EditImages">
                                <img src={EditImages} />
                              </span>
                              <span className="ActionsList"> Approve</span>
                            </span>
                          </button>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          );
        },
      },
    ],
    [sno],
  );

  const HandleOldemployee = (e) => {
    setdtPageindex(1);
    setOldEMp(e);
    dispatch(setthe_eployee_exit_flow_employee_filters(e));
    if (e != null) {
      setoldemp({
        ...oldemplo,
        old_employee: e.value,
      });
    }
  };

  const HandleSubmits = () => {};

  const ClearState = (Counts) => {
    if (Counts == 2) {
      dispatch(setTheNew_exit_flowStateStatus({ value: "", label: "All" }));

      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    // console.log(Counts, values, sel, "Logs");
    // console.log(SelectedValues, "selectedvaluess");
    setSelected(sel);
    SetStates(true);
    dispatch(setTheNew_exit_flowStateStatus(SelectedValues));
    if (values == "Completed") {
      SetSelectval({
        ///Completed
        ...selectVal,
        status: "completed",
      });
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
  let objectArray = [];
  //console.log(state.NumberCounts.namerednder, "names");
  options.map((item) => {
    if (item.value == 1 && state.NumberCounts.namerednder == "") {
      objectArray.push({ value: item.value, label: item.label });
    } else if (
      item.value == 1 &&
      state.NumberCounts.namerednder == "completed"
    ) {
      objectArray.push({ value: item.value, label: item.label });
    } else if (item.value == 1 && state.NumberCounts.namerednder == "Decline") {
      objectArray.push({ value: item.value, label: item.label });
    }
  });

  const currentRef = useRef();
  const scrollPosition = (e) => {
    const val = currentRef.current.scrollTop;
    sessionStorage.setItem("NewExitflowlistrequestScrollpages", val);
  };

  const HandleTheExports = () => {
    const payloads = {
      state: data?.state,
      region: data?.region,
      zone: data?.zone,
      search: search,
      status: selectVal?.status,
      from_date: range[0],
      to_date: range[1],
      range: true,
      old_employee: oldemplo.old_employee,
    };
    dispatch(setTheExitNewFlowDetailsExportActions(payloads));
  };

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setThenew_exit_flowFromDate(range[0]));
      dispatch(setThenew_exit_flowToDate(range[1]));
    }
    if (state.exit_flow_managemanets.Exit_flowToDate == "") {
      dispatch(setThenew_exit_flowFromDate(today_day));
      dispatch(setThenew_exit_flowToDate(today_day));
    }
  }, [range]);
  return (
    <>
      <div
        onScroll={scrollPosition}
        ref={currentRef}
        className={stateDisplay ? "outterContent" : "inner-Content"}
      >
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Exit </h3>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              placeholder={"Search"}
              value={multiselect}
            />
          </div>
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={
                multiselect1
                  ? Array.isArray(multiselect1)
                    ? multiselect1.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect1.label === "ALL" ||
                        multiselect1.label === "All"
                      ? false
                      : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            />
          </div>
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              options={nameList4}
              isClearable={
                multiselect3
                  ? Array.isArray(multiselect3)
                    ? multiselect3.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect3.label === "ALL" ||
                        multiselect3.label === "All"
                      ? false
                      : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect3}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>
          <div className="col-sm-2 ">
            <label
              for="validationCustom01 "
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={
                  state.EmployeeVerificationsNeed.employeelistFROMDATE != ""
                    ? [
                        new Date(
                          state.exit_flow_managemanets.Exit_flowFromDate,
                        ),
                        new Date(state.exit_flow_managemanets.Exit_flowToDate),
                      ]
                    : [new Date(range[0]), new Date(range[1])]
                }
                components={{
                  ClearButton: () => null,
                }}
                //               onOpen={() => {
                //                 openMe()
                //               }}
                // onClose={() => {
                //   CloseDateRange()
                // }}

                ref={dateRangeRef}
                onOpen={() => {
                  setTimeout(() => {
                    alignDateRangePicker(dateRangeRef.current);
                  }, 80);
                }}
                style={{
                  width: "100%",
                  padding: "0px 5px",
                }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000;
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
          <div className="col-sm-2" style={{ paddingTop: "18px" }}>
            <button
              align="center"
              type="button"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                background: "transparent",
              }}
              className="DownloadBTNS"
              onClick={(e) => {
                HandleTheExports();
              }}
            >
              <a class="dnbtn"></a>
            </button>
          </div>
        </div>

        {Data != undefined ? (
          <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
            <ReactTable
              data={state.ExitFlow_List.exitFlowList}
              columns={columns}
              totalItems={state.ExitFlow_List.total_counts}
              currentPage={currentPage}
              // onPageChange={handlePageChange}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={state.ExitFlow_List.total_counts}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              values={state.exit_flow_managemanets.Exit_flowStatusState}
              options={options}
              Filter={Filter}
              count={count}
              ClearState={ClearState}
              placeHold={place}
              ///--- emoloyee role based filters -

              setsno={setsno}
              sno={sno}
              id={"spe"}
              ApproveRequestFilter={true}
              searchVal={
                TablePositionPersist?.ExitnewflowlistRequestedPagelist
                  ?.search == "" ||
                TablePositionPersist?.ExitnewflowlistRequestedPagelist
                  ?.search == undefined
                  ? ""
                  : TablePositionPersist.ExitnewflowlistRequestedPagelist.search
              }
              search_key={true}
              OldEmployeFilters={true}
              oldemloyeeOptions={oldemloyeeOptions}
              OldEmp={OldEmp}
              HandleOldemployee={(e) => {
                HandleOldemployee(e);
              }}
            />
          </div>
        ) : null}
      </div>

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete"}
        />
      ) : null}

      {EmployeePop && EmployeeIDs != undefined ? (
        <Exitflowaaprove
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          selectVal={selectVal?.status}
          filter_list={data}
          white_collar={filterForWhite.white_collar}
          old_employee={oldemplo.old_employee}
        />
      ) : null}
    </>
  );
};

export default Exitnewlist;
